// src/data/courseData.js
// Расширенная база знаний с Frontend темами

export const COURSE_DATA = {
  title: "Основы веб-разработки",
  courses: [
    {
      id: 'python',
      name: 'Python',
      icon: '🐍',
      color: 'bg-blue-500'
    },
    {
      id: 'javascript',
      name: 'JavaScript',
      icon: '⚡',
      color: 'bg-yellow-500'
    },
    {
      id: 'html',
      name: 'HTML',
      icon: '📄',
      color: 'bg-orange-500'
    },
    {
      id: 'css',
      name: 'CSS',
      icon: '🎨',
      color: 'bg-purple-500'
    },
    {
      id: 'react',
      name: 'React',
      icon: '⚛️',
      color: 'bg-cyan-500'
    }
  ],
  materials: {
    python: [
      {
        id: 1,
        topic: "Переменные и типы данных",
        category: "python",
        content: "В Python существует несколько базовых типов данных: int (целые числа), float (числа с плавающей точкой), str (строки), bool (логический тип). Переменные создаются простым присваиванием: x = 10. Python — язык с динамической типизацией, тип определяется автоматически.",
        detailedContent: `Python поддерживает динамическую типизацию, что означает, что вам не нужно явно объявлять тип переменной. Интерпретатор автоматически определяет тип на основе присваиваемого значения.

Основные типы данных в Python:
- int (целые числа): используются для представления целых чисел без дробной части. Пример: x = 42
- float (числа с плавающей точкой): используются для представления десятичных чисел. Пример: pi = 3.14159
- str (строки): последовательности символов, заключенные в одинарные, двойные или тройные кавычки. Пример: name = "Python"
- bool (логический тип): представляет истину (True) или ложь (False). Пример: is_active = True

Переменные в Python создаются в момент первого присваивания значения. Вы можете изменить тип переменной, просто присвоив ей значение другого типа. Python также поддерживает множественное присваивание: x, y, z = 1, 2, 3`,
        examples: [
          {
            title: "Создание переменных разных типов",
            code: `# Целые числа
age = 25
year = 2024

# Числа с плавающей точкой
temperature = 36.6
pi = 3.14159

# Строки
name = "Алексей"
greeting = 'Привет, мир!'

# Логические значения
is_student = True
has_passed = False

# Проверка типа
print(type(age))  # <class 'int'>
print(type(temperature))  # <class 'float'>
print(type(name))  # <class 'str'>`,
            explanation: "Функция type() позволяет узнать тип любой переменной"
          },
          {
            title: "Множественное присваивание",
            code: `# Присваивание нескольких переменных одновременно
x, y, z = 10, 20, 30

# Обмен значениями переменных
a = 5
b = 10
a, b = b, a  # Теперь a = 10, b = 5

print(f"x={x}, y={y}, z={z}")  # x=10, y=20, z=30
print(f"a={a}, b={b}")  # a=10, b=5`,
            explanation: "Python позволяет присваивать значения нескольким переменным в одной строке"
          }
        ],
        keyPoints: [
          "Python использует динамическую типизацию - тип определяется автоматически",
          "Основные типы: int, float, str, bool",
          "Переменные не требуют явного объявления типа",
          "Используйте функцию type() для проверки типа переменной",
          "Можно изменять тип переменной, присваивая новое значение другого типа"
        ]
      },
      {
        id: 2,
        topic: "Циклы",
        category: "python",
        content: "В Python есть два основных типа циклов: for и while. Цикл for используется для перебора элементов последовательности: for i in range(10). Цикл while выполняется пока условие истинно: while x < 100. Для досрочного выхода используется break, для перехода к следующей итерации — continue.",
        detailedContent: `Циклы позволяют выполнять блок кода многократно. В Python есть два основных типа циклов: for и while.

Цикл for используется для итерации по последовательности (список, кортеж, строка, range и т.д.). Это наиболее распространенный способ создания циклов в Python, когда вы знаете количество итераций заранее или хотите пройтись по всем элементам коллекции.

Цикл while выполняется до тех пор, пока условие остается истинным. Этот тип цикла полезен, когда количество итераций заранее неизвестно.

Управление циклами:
- break: немедленно прерывает выполнение цикла
- continue: пропускает оставшуюся часть текущей итерации и переходит к следующей
- else: блок кода, который выполняется после нормального завершения цикла (если не было break)

Функция range() часто используется с циклом for для генерации последовательности чисел. Синтаксис: range(start, stop, step)`,
        examples: [
          {
            title: "Цикл for с range()",
            code: `# Простой цикл от 0 до 4
for i in range(5):
    print(i)  # 0, 1, 2, 3, 4

# Цикл с началом и концом
for i in range(2, 8):
    print(i)  # 2, 3, 4, 5, 6, 7

# Цикл с шагом
for i in range(0, 10, 2):
    print(i)  # 0, 2, 4, 6, 8`,
            explanation: "range(start, stop, step) генерирует последовательность чисел"
          },
          {
            title: "Цикл while",
            code: `# Простой while цикл
count = 0
while count < 5:
    print(f"Счетчик: {count}")
    count += 1

# While с условием
password = ""
while password != "123":
    password = input("Введите пароль: ")
print("Доступ разрешен!")`,
            explanation: "while выполняется пока условие истинно"
          },
          {
            title: "Использование break и continue",
            code: `# Break - выход из цикла
for i in range(10):
    if i == 5:
        break  # Прерываем цикл при i=5
    print(i)  # Выведет: 0, 1, 2, 3, 4

# Continue - пропуск итерации
for i in range(5):
    if i == 2:
        continue  # Пропускаем когда i=2
    print(i)  # Выведет: 0, 1, 3, 4`,
            explanation: "break и continue управляют выполнением цикла"
          }
        ],
        keyPoints: [
          "for используется для итерации по последовательностям",
          "while выполняется пока условие истинно",
          "range(start, stop, step) генерирует последовательность чисел",
          "break прерывает цикл, continue переходит к следующей итерации",
          "Циклы могут иметь блок else, который выполняется после нормального завершения"
        ]
      },
      {
        id: 3,
        topic: "Функции",
        category: "python",
        content: "Функции в Python определяются ключевым словом def. Синтаксис: def имя_функции(параметры): тело функции. Функция может возвращать значение через return. Аргументы могут быть позиционными, именованными, или иметь значения по умолчанию. Пример: def sum(a, b=0): return a + b",
        detailedContent: `Функции — это основной инструмент для организации и повторного использования кода в Python. Функция — это блок кода, который выполняется только тогда, когда его вызывают.

Функции определяются с помощью ключевого слова def, после которого идет имя функции и список параметров в скобках. Тело функции отделяется отступом.

Параметры и аргументы:
- Позиционные аргументы: передаются в том же порядке, в котором определены параметры
- Аргументы по умолчанию: параметры с предустановленными значениями, которые используются, если аргумент не передан
- Именованные аргументы (keyword arguments): передаются по имени, порядок не важен
- *args: позволяет принимать произвольное количество позиционных аргументов
- **kwargs: позволяет принимать произвольное количество именованных аргументов

Функция может возвращать значение с помощью оператора return. Если return не указан, функция возвращает None.`,
        examples: [
          {
            title: "Простая функция с return",
            code: `def greet(name):
    return f"Привет, {name}!"

message = greet("Алеша")
print(message)  # Привет, Алеша!`,
            explanation: "Функция принимает имя и возвращает строку приветствия"
          },
          {
            title: "Аргументы по умолчанию",
            code: `def power(base, exp=2):
    return base ** exp

print(power(3))     # 9  (3^2)
print(power(2, 3))  # 8  (2^3)
print(power(5, 0))  # 1  (5^0)`,
            explanation: "Параметр exp имеет значение по умолчанию 2, можно его не передавать"
          },
          {
            title: "*args и **kwargs",
            code: `def show_info(*args, **kwargs):
    print("Позиционные:", args)
    print("Именованные:", kwargs)

show_info(1, 2, 3, name="Иван", age=25)
# Позиционные: (1, 2, 3)
# Именованные: {'name': 'Иван', 'age': 25}`,
            explanation: "*args собирает позиционные аргументы в кортеж, **kwargs — именованные в словарь"
          }
        ],
        keyPoints: [
          "Функции определяются через def имя(параметры):",
          "return возвращает значение из функции",
          "Аргументы по умолчанию ставятся в конце списка параметров",
          "*args для произвольного количества позиционных аргументов",
          "**kwargs для произвольного количества именованных аргументов",
          "Без return функция возвращает None"
        ]
      },
      {
        id: 4,
        topic: "Списки",
        category: "python",
        content: "Список (list) — изменяемая упорядоченная коллекция элементов. Создание: my_list = [1, 2, 3] или my_list = list(). Основные методы: append() — добавить элемент, remove() — удалить, sort() — сортировать, len() — получить длину. Индексация с 0, поддерживаются срезы: my_list[1:3]",
        detailedContent: `Список (list) — один из самых часто используемых типов данных в Python. Это упорядоченная коллекция элементов, которая может содержать элементы разных типов. Списки изменяемы, что означает, что вы можете добавлять, удалять и менять элементы после создания.

Индексация: элементы списка нумеруются с 0. Поддерживается негативная индексация: -1 это последний элемент, -2 предпоследний и т.д.

Срезы (slicing): позволяют получить подмножество списка. Синтаксис: list[start:stop:step]. Например, my_list[1:4] возвращает элементы с индексами 1, 2, 3.

Основные методы списка:
- append(x): добавляет элемент x в конец списка
- insert(i, x): вставляет элемент x на позицию i
- remove(x): удаляет первое вхождение элемента x
- pop(i): удаляет и возвращает элемент по индексу i (по умолчанию последний)
- sort(): сортирует список на месте
- reverse(): разворачивает список на месте
- copy(): создает копию списка`,
        examples: [
          {
            title: "Индексация и срезы",
            code: `fruits = ["яблоко", "банан", "апельсин", "груша", "виноград"]

# Индексация
print(fruits[0])   # яблоко
print(fruits[-1])  # виноград

# Срезы
print(fruits[1:3])   # ['банан', 'апельсин']
print(fruits[::2])   # ['яблоко', 'апельсин', 'виноград']
print(fruits[::-1])  # Полный разворот списка`,
            explanation: "Срез [start:stop:step] позволяет гибко извлекать элементы списка"
          },
          {
            title: "Добавление и удаление",
            code: `numbers = [1, 2, 3]

numbers.append(4)       # [1, 2, 3, 4]
numbers.insert(1, 10)   # [1, 10, 2, 3, 4]
numbers.remove(10)      # [1, 2, 3, 4]

popped = numbers.pop()  # popped = 4
print(numbers)          # [1, 2, 3]`,
            explanation: "append добавляет в конец, insert — на позицию, pop удаляет и возвращает"
          },
          {
            title: "List comprehension",
            code: `# Обычный цикл
squares = []
for x in range(6):
    squares.append(x ** 2)

# List comprehension (то же самое, но короче)
squares = [x ** 2 for x in range(6)]
print(squares)  # [0, 1, 4, 9, 16, 25]

# С условием
evens = [x for x in range(10) if x % 2 == 0]
print(evens)  # [0, 2, 4, 6, 8]`,
            explanation: "List comprehension — краткий и быстрый способ создания списков"
          }
        ],
        keyPoints: [
          "Списки создаются через [] или list()",
          "Индексация с 0, негативная индексация с -1",
          "Срезы list[start:stop:step] для получения подмножества",
          "append() добавляет в конец, insert() — на позицию",
          "List comprehension — краткий способ создания списков с условиями"
        ]
      }
    ],
    javascript: [
      {
        id: 5,
        topic: "Переменные в JavaScript",
        category: "javascript",
        content: "В JavaScript есть три способа объявления переменных: var (устаревший), let (изменяемая) и const (константа). Используйте const по умолчанию, let когда нужно изменить значение. JavaScript — динамически типизированный язык.",
        detailedContent: `В современном JavaScript существуют три способа объявления переменных: var, let и const. Каждый из них имеет свои особенности и область применения.

var - устаревший способ объявления переменных. Имеет функциональную область видимости и подвержен hoisting (поднятию). В современном коде не рекомендуется использовать var.

let - используется для объявления переменных, значение которых может изменяться. Имеет блочную область видимости, что делает код более предсказуемым и безопасным.

const - используется для объявления констант, значение которых не будет переназначено. Это не означает, что значение неизменяемо (immutable) - для объектов и массивов можно изменять их содержимое, но нельзя переназначить саму переменную.

Правило большого пальца: всегда используйте const по умолчанию. Используйте let только когда знаете, что значение переменной будет изменяться. Избегайте var.

JavaScript - динамически типизированный язык, что означает, что тип переменной определяется во время выполнения и может меняться.`,
        examples: [
          {
            title: "Объявление переменных с let и const",
            code: `// const - значение не изменяется
const PI = 3.14159;
const userName = "Иван";

// Попытка изменить const приведет к ошибке
// PI = 3.14; // TypeError: Assignment to constant variable

// let - значение может изменяться
let age = 25;
age = 26; // OK
let counter = 0;
counter++; // OK

// Блочная область видимости
if (true) {
  let blockVar = "Я внутри блока";
  console.log(blockVar); // OK
}
// console.log(blockVar); // ReferenceError`,
            explanation: "const используется для неизменяемых переменных, let - для изменяемых"
          },
          {
            title: "const с объектами и массивами",
            code: `// const не делает объект неизменяемым
const user = {
  name: "Анна",
  age: 30
};

// Можно изменять свойства
user.age = 31; // OK
user.email = "anna@example.com"; // OK

// Но нельзя переназначить саму переменную
// user = {}; // TypeError

// То же самое с массивами
const numbers = [1, 2, 3];
numbers.push(4); // OK
numbers[0] = 10; // OK
// numbers = []; // TypeError`,
            explanation: "const запрещает переназначение переменной, но не изменение содержимого объектов/массивов"
          },
          {
            title: "Разница между var и let",
            code: `// var - функциональная область видимости
function varTest() {
  var x = 1;
  if (true) {
    var x = 2; // та же переменная!
    console.log(x); // 2
  }
  console.log(x); // 2
}

// let - блочная область видимости
function letTest() {
  let x = 1;
  if (true) {
    let x = 2; // другая переменная
    console.log(x); // 2
  }
  console.log(x); // 1
}`,
            explanation: "let имеет блочную область видимости, var - функциональную"
          }
        ],
        keyPoints: [
          "Используйте const по умолчанию для всех переменных",
          "Используйте let только когда значение должно изменяться",
          "Избегайте использования var в современном коде",
          "const запрещает переназначение, но не изменение содержимого объектов",
          "let и const имеют блочную область видимости"
        ]
      },
      {
        id: 6,
        topic: "Функции и стрелочные функции",
        category: "javascript",
        content: "Функции объявляются через function или стрелочный синтаксис (=>). Стрелочные функции короче и не имеют собственного this. Функции — объекты первого класса, могут передаваться как аргументы.",
        detailedContent: `Функции в JavaScript — это объекты первого класса, что означает, что они могут быть присвоены переменным, передаваться как аргументы и возвращаться из других функций.

Есть два основных способа объявления функций: через function и через стрелочный синтаксис (arrow functions).

function declaration:
Объявление через ключевое слово function. Такие функции поднимаются (hoisting) — доступны до строки объявления.

Arrow functions (стрелочные функции):
Введены в ES6. Имеют более краткий синтаксис. Ключевое отличие: стрелочные функции не имеют собственного this, они наследуют this из окружающего контекста. Это особенно важно при работе с объектами и React.

Если стрелочная функция содержит одно выражение, можно опустить фигурные скобки и return — значение возвращается автоматически.`,
        examples: [
          {
            title: "function vs arrow function",
            code: `// Function declaration
function add(a, b) {
  return a + b;
}

// Arrow function (то же самое)
const addArrow = (a, b) => a + b;

// Arrow с одним параметром (скобки необязательны)
const double = x => x * 2;

// Arrow с телом функции
const greet = (name) => {
  const message = "Привет, " + name;
  return message;
};

console.log(add(2, 3));      // 5
console.log(addArrow(2, 3)); // 5`,
            explanation: "Arrow functions — более краткий синтаксис и иное поведение this"
          },
          {
            title: "Функции как аргументы (callbacks)",
            code: `function doOperation(a, b, operation) {
  return operation(a, b);
}

const multiply = (a, b) => a * b;

console.log(doOperation(4, 5, multiply));           // 20
console.log(doOperation(4, 5, (a, b) => a + b));    // 9
console.log(doOperation(4, 5, (a, b) => a - b));    // -1`,
            explanation: "Функция может принимать другую функцию как аргумент — это callback"
          }
        ],
        keyPoints: [
          "function declaration поднимается (hoisting), arrow function — нет",
          "Arrow functions не имеют собственного this",
          "Однострочные arrow functions автоматически возвращают результат",
          "Функции — объекты первого класса, их можно передавать как аргументы",
          "Callback — функция, передаваемая другой функции для выполнения"
        ]
      },
      {
        id: 7,
        topic: "Массивы и методы",
        category: "javascript",
        content: "Массивы в JS — это объекты. Основные методы: map() (преобразование), filter() (фильтрация), reduce() (свертка), forEach() (итерация), find() (поиск). Все методы кроме forEach возвращают новый массив.",
        detailedContent: `Массивы в JavaScript — это специальные объекты для хранения упорядоченных наборов значений. Они индексируются числами начиная с 0.

Массивы JS поддерживают множество встроенных методов. Их можно разделить на две группы:
- Методы, которые изменяют оригинальный массив (мутирующие): push, pop, splice, sort, reverse
- Методы, которые возвращают новый массив (иммутабельные): map, filter, slice, concat

Наиболее используемые методы для работы с массивами:
- map(): создает новый массив, применяя функцию к каждому элементу
- filter(): создает новый массив с элементами, для которых функция возвращает true
- reduce(): сворачивает массив в одно значение, применяя функцию аккумулятора
- find(): возвращает первый элемент, для которого функция возвращает true
- some(): проверяет, есть ли хотя бы один элемент, удовлетворяющий условию
- every(): проверяет, удовлетворяют ли все элементы условию`,
        examples: [
          {
            title: "map, filter, reduce",
            code: `const numbers = [1, 2, 3, 4, 5];

// map — преобразование каждого элемента
const doubled = numbers.map(n => n * 2);
console.log(doubled);  // [2, 4, 6, 8, 10]

// filter — фильтрация
const evens = numbers.filter(n => n % 2 === 0);
console.log(evens);  // [2, 4]

// reduce — свертка в одно значение
const sum = numbers.reduce((acc, n) => acc + n, 0);
console.log(sum);  // 15`,
            explanation: "map, filter, reduce — три самых часто используемых метода массивов"
          },
          {
            title: "find, some, every",
            code: `const users = [
  { name: "Анна", age: 25 },
  { name: "Борис", age: 30 },
  { name: "Вера", age: 22 }
];

// find — первый подходящий элемент
const boris = users.find(u => u.name === "Борис");
console.log(boris);  // { name: "Борис", age: 30 }

// some — есть ли хотя бы один
console.log(users.some(u => u.age > 28));   // true

// every — все ли подходят
console.log(users.every(u => u.age > 20));  // true`,
            explanation: "find возвращает элемент, some/every — boolean"
          }
        ],
        keyPoints: [
          "map() создает новый массив с преобразованными элементами",
          "filter() возвращает массив элементов, удовлетворяющих условию",
          "reduce() сворачивает массив в одно значение",
          "find() возвращает первый элемент по условию",
          "some()/every() возвращают boolean для проверки условий"
        ]
      },
      {
        id: 8,
        topic: "Асинхронность: Promises и async/await",
        category: "javascript",
        content: "Promise — объект для работы с асинхронными операциями. Имеет состояния: pending, fulfilled, rejected. async/await — синтаксический сахар над промисами. Async функция всегда возвращает Promise, await ждет выполнения.",
        detailedContent: `Асинхронность — ключевая концепция в JavaScript. JavaScript однопоточный, и для работы с долгими операциями (загрузка данных, таймеры) используются асинхронные механизмы.

Promise — объект, который представляет результат будущей операции. У промиса три состояния:
- pending (ожидание): операция еще не завершена
- fulfilled (выполнено): операция успешно завершена
- rejected (отклонено): произошла ошибка

Для работы с промисами есть два способа:
1. Цепочки .then() и .catch()
2. async/await (рекомендуется)

async/await — синтаксический сахар над промисами. Функция, объявленная через async, всегда возвращает Promise. Оператор await ожидает завершения промиса и возвращает его значение. await может использоваться только внутри async функции.

Обработка ошибок в async/await делается через обычный try/catch блок, что намного проще, чем через .catch() в цепочках промисов.`,
        examples: [
          {
            title: "Создание и использование Promise",
            code: `const fetchData = new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve("Данные загружены!");
  }, 1000);
});

// С .then()
fetchData.then(data => console.log(data));

// Или через async/await
async function getData() {
  const data = await fetchData;
  console.log(data);  // "Данные загружены!"
}

getData();`,
            explanation: "Promise resolve передает результат, reject — ошибку"
          },
          {
            title: "async/await с обработкой ошибок",
            code: `async function loadUser(id) {
  try {
    const response = await fetch(
      \`https://api.example.com/users/\${id}\`
    );

    if (!response.ok) {
      throw new Error("Пользователь не найден");
    }

    const user = await response.json();
    return user;
  } catch (error) {
    console.error("Ошибка:", error.message);
    return null;
  }
}

const user = await loadUser(1);`,
            explanation: "try/catch в async функции перехватывает ошибки из await"
          }
        ],
        keyPoints: [
          "Promise имеет 3 состояния: pending, fulfilled, rejected",
          "async функция всегда возвращает Promise",
          "await останавливает выполнение до завершения промиса",
          "await можно использовать только в async функциях",
          "Ошибки в async/await обрабатываются через try/catch"
        ]
      }
    ],
    html: [
      {
        id: 9,
        topic: "Структура HTML документа",
        category: "html",
        content: "HTML документ состоит из DOCTYPE, тега html с head и body. В head — метаданные (title, meta, link). В body — контент страницы. Все теги должны быть закрыты (кроме самозакрывающихся).",
        detailedContent: `HTML (HyperText Markup Language) — языке разметки для создания веб-страниц. Каждый HTML документ имеет четкую структуру.

DOCTYPE: первая строка документа, которая говорит браузеру, какую версию HTML использовать. <!DOCTYPE html> означает HTML5.

<html>: корневой элемент документа, внутри которого находятся все остальные элементы.

<head>: содержит метаданные — информацию о странице, которая не отображается на экране:
- <title>: название вкладки в браузере
- <meta>: информация о кодировке, описание страницы, viewport
- <link>: подключение внешних ресурсов (CSS файлы, иконки)
- <script>: подключение скриптов

<body>: содержит видимый контент страницы — текст, изображения, ссылки и все то, что видит пользователь.`,
        examples: [
          {
            title: "Базовая структура HTML",
            code: `<!DOCTYPE html>
<html lang="ru">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Моя Страница</title>
    <link rel="stylesheet" href="style.css">
</head>
<body>
    <h1>Добро пожаловать!</h1>
    <p>Это моя первая веб-страница.</p>
    <script src="script.js"></script>
</body>
</html>`,
            explanation: "Каждый HTML документ должен содержать DOCTYPE, html, head и body"
          }
        ],
        keyPoints: [
          "DOCTYPE html определяет версию HTML5",
          "<head> содержит метаданные (невидимые пользователю)",
          "<body> содержит видимый контент страницы",
          "<meta charset> устанавливает кодировку документа",
          "lang='ru' помогает поисковикам определить язык страницы"
        ]
      },
      {
        id: 10,
        topic: "Семантические теги",
        category: "html",
        content: "Семантические теги описывают смысл содержимого: header (шапка), nav (навигация), main (основной контент), article (статья), section (секция), aside (боковая панель), footer (подвал). Улучшают SEO и доступность.",
        detailedContent: `Семантические теги — это HTML элементы, которые несут в себе смысл содержимого, а не просто разметку. В отличие от <div> и <span>, семантические теги говорят и поисковым системам, и разработчикам, что означает тот или иной блок контента.

Почему семантика важна:
- SEO: поисковые системы лучше индексируют контент, когда структура имеет смысл
- Доступность: скрин-ридеры (для слабовидящих) лучше навигируют по семантическому контенту
- Читаемость кода: другим разработчикам проще понять структуру страницы
- Стилизация: можно стилизовать элементы по тегам без лишних CSS классов

Основные семантические теги:
- <header>: шапка — логотип, навигация, приветствие
- <nav>: навигационные ссылки
- <main>: основной контент страницы (один на страницу)
- <article>: самодостаточный блок контента (статья, пост)
- <section>: тематический раздел контента
- <aside>: боковой контент, связанный с основным
- <footer>: подвал — копирайт, контакты, ссылки`,
        examples: [
          {
            title: "Семантическая структура страницы",
            code: `<header>
    <nav>
        <ul>
            <li><a href="/">Главная</a></li>
            <li><a href="/about">О нас</a></li>
        </ul>
    </nav>
</header>

<main>
    <article>
        <h1>Заголовок статьи</h1>
        <p>Текст статьи...</p>
    </article>

    <aside>
        <h2>Рекомендации</h2>
        <ul>...</ul>
    </aside>
</main>

<footer>
    <p>© 2024 Моя компания</p>
</footer>`,
            explanation: "Каждый тег говорит о роли блока в структуре страницы"
          }
        ],
        keyPoints: [
          "Семантические теги несут смысл контента",
          "<main> — один на страницу, это главный контент",
          "<article> — самодостаточный блок (статья, пост)",
          "<nav> используется только для навигационных ссылок",
          "Семантика улучшает SEO и доступность сайта"
        ]
      },
      {
        id: 11,
        topic: "Формы и input элементы",
        category: "html",
        content: "Формы создаются тегом form. Основные input типы: text, email, password, number, date, checkbox, radio, file. Атрибуты: name (для отправки), placeholder (подсказка), required (обязательное), pattern (валидация).",
        detailedContent: `Формы — основной способ сбора данных от пользователей на веб-сайтах. Они создаются с помощью тега <form>, внутри которого размещаются элементы ввода.

Атрибуты <form>:
- action: URL, куда отправляются данные формы
- method: способ отправки (GET или POST)

Элемент <input> — самый часто используемый. Его тип определяется атрибутом type:
- text: однострочное текстовое поле
- email: поле для email с валидацией
- password: поле пароля (символы скрыты)
- number: числовое поле со стрелками
- date: выбор даты
- checkbox: несколько вариантов (можно выбрать несколько)
- radio: несколько вариантов (только один)
- file: загрузка файлов
- submit: кнопка отправки формы

Валидация формы:
- required: поле обязательное
- min/max: для числовых полей
- minlength/maxlength: для текстовых полей
- pattern: регулярное выражение для валидации`,
        examples: [
          {
            title: "Полная форма регистрации",
            code: `<form action="/register" method="POST">
    <label for="name">Имя:</label>
    <input type="text" id="name" name="name"
           placeholder="Введите имя" required>

    <label for="email">Email:</label>
    <input type="email" id="email" name="email"
           placeholder="you@example.com" required>

    <label for="password">Пароль:</label>
    <input type="password" id="password"
           name="password" minlength="6" required>

    <label>
        <input type="checkbox" name="agree" required>
        Согласен с условиями
    </label>

    <button type="submit">Зарегистрироваться</button>
</form>`,
            explanation: "label связывается с input через for/id для доступности"
          }
        ],
        keyPoints: [
          "<form> оборачивает все элементы ввода формы",
          "type определяет тип поля ввода (text, email, password и т.д.)",
          "required делает поле обязательным для отправки",
          "<label> связывается с input для улучшения доступности",
          "method='POST' используется для отправки данных формы"
        ]
      }
    ],
    css: [
      {
        id: 12,
        topic: "Селекторы CSS",
        category: "css",
        content: "Селекторы выбирают элементы для стилизации. Типы: элемент (div), класс (.class), id (#id), атрибут ([type='text']), псевдоклассы (:hover, :focus), псевдоэлементы (::before, ::after). Комбинаторы: потомок (пробел), ребенок (>), соседний (+).",
        detailedContent: `Селекторы CSS — это способ указать, к каким HTML элементам применять стили. Правильный выбор селектора — залог чистого и поддерживаемого CSS кода.

Типы селекторов по приоритету (от низшего к высшему):
1. Элементный селектор (div, p): самый низкий приоритет
2. Класс (.class): средний приоритет
3. ID (#id): высокий приоритет
4. Inline styles: самый высокий приоритет

Комбинаторы позволяют выбрать элементы по их позиции в DOM дереве:
- Потомок (пробел): div p выбирает все <p> внутри <div> (любой уровень вложенности)
- Ребенок (>): div > p выбирает <p>, который является прямым ребенком <div>
- Соседний (+): h1 + p выбирает <p>, идущий сразу после <h1>
- Общий (~): h1 ~ p выбирает все <p> после <h1> в том же родителе

Псевдоклассы (:hover, :focus, :first-child) и псевдоэлементы (::before, ::after) позволяют стилизовать элементы в зависимости от состояния или добавлять виртуальный контент.`,
        examples: [
          {
            title: "Различные типы селекторов",
            code: `/* Элемент */
p { color: gray; }

/* Класс */
.highlight { background: yellow; }

/* ID */
#main-title { font-size: 2rem; }

/* Атрибут */
input[type="email"] { border: 1px solid blue; }

/* Комбинатор потомок */
nav a { text-decoration: none; }

/* Комбинатор ребенок */
ul > li { list-style: none; }

/* Псевдокласс */
a:hover { color: red; }

/* Псевдоэлемент */
p::first-letter { font-size: 1.5rem; }`,
            explanation: "Каждый тип селектора имеет свою специфику и приоритет"
          }
        ],
        keyPoints: [
          "ID (#id) имеет больший приоритет, чем класс (.class)",
          "Класс можно использовать многократно, ID — один раз",
          "Комбинатор > выбирает только прямых потомков",
          "Псевдоклассы (:hover) стилизуют состояния элемента",
          "Псевдоэлементы (::before) создают виртуальный контент"
        ]
      },
      {
        id: 13,
        topic: "Flexbox",
        category: "css",
        content: "Flexbox — одномерная компоновка (строка или столбец). Контейнер: display: flex, flex-direction, justify-content (главная ось), align-items (поперечная ось), gap (отступы). Элементы: flex-grow, flex-shrink, flex-basis.",
        detailedContent: `Flexbox (Flexible Box Layout) — система компоновки для создания гибких и адаптивных раскладок. Работает в одном измерении — либо по горизонтали (row), либо по вертикали (column).

Концепция: есть контейнер (flex container) и элементы внутри него (flex items). Поведение элементов управляется свойствами контейнера и самих элементов.

Свойства контейнера:
- display: flex — превращает элемент в flex контейнер
- flex-direction: row | column — направление главной оси
- justify-content — выравнивание по главной оси (center, space-between, flex-start)
- align-items — выравнивание по поперечной оси (center, stretch, flex-start)
- flex-wrap: wrap — позволяет элементам перейти на новую строку
- gap — отступы между элементами

Свойства flex items:
- flex-grow: коэффициент роста (как элемент растет)
- flex-shrink: коэффициент усадки
- flex: сокращение для grow, shrink, basis`,
        examples: [
          {
            title: "Центрирование и space-between",
            code: `/* Центрирование по обе оси */
.center {
  display: flex;
  justify-content: center;  /* горизонталь */
  align-items: center;      /* вертикаль */
  height: 100vh;
}

/* Навигация с space-between */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
}`,
            explanation: "justify-content и align-items — ключевые свойства для выравнивания"
          },
          {
            title: "Адаптивная сетка с flex",
            code: `.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.card {
  flex: 1 1 300px;
  /* grow: растет заполняя место */
  /* shrink: 1 - может усадиться */
  /* basis: минимальная ширина 300px */
}`,
            explanation: "flex: 1 1 300px создает адаптивные карточки с минимальной шириной"
          }
        ],
        keyPoints: [
          "display: flex создает контейнер, элементы внутри — flex items",
          "flex-direction: row по умолчанию (горизонталь)",
          "justify-content выравнивает по главной оси",
          "align-items выравнивает по поперечной оси",
          "flex-wrap: wrap позволяет элементам переходить на новую строку",
          "flex: 1 1 auto — сокращение для grow, shrink, basis"
        ]
      },
      {
        id: 14,
        topic: "Grid Layout",
        category: "css",
        content: "Grid — двумерная компоновка (строки и столбцы). Контейнер: display: grid, grid-template-columns/rows (определение сетки), gap (отступы). Элементы: grid-column, grid-row (размещение), grid-area (именованные области).",
        detailedContent: `CSS Grid — система двумерной компоновки, позволяющая создавать сложные раскладки с помощью строк и столбцов. В отличие от Flexbox, Grid работает одновременно в двух измерениях.

Ключевые концепции:
- Grid container: элемент с display: grid
- Grid items: прямые потомки контейнера
- Grid lines: линии, образующие сетку
- Grid cells: пересечение строки и столбца
- Grid area: прямоугольная область, состоящая из нескольких ячеек

Определение сетки:
- grid-template-columns: определяет количество и ширину столбцов
- grid-template-rows: определяет количество и высоту строк
- fr (fractional unit): гибкая единица, занимающая долю доступного пространства

Размещение элементов:
- grid-column: определяет в каких столбцах находится элемент
- grid-row: определяет в каких строках находится элемент
- grid-area: именованная область для размещения`,
        examples: [
          {
            title: "Простая сетка 3 столбца",
            code: `.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  /* или: repeat(3, 1fr) */
  gap: 1rem;
}

/* Каждый .item автоматически укладывается */
.item {
  background: #ddd;
  padding: 1rem;
  text-align: center;
}`,
            explanation: "1fr 1fr 1fr делит пространство на 3 равные колонки"
          },
          {
            title: "Сложная раскладка страницы",
            code: `.page {
  display: grid;
  grid-template-columns: 200px 1fr 250px;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "header header header"
    "sidebar main aside"
    "footer footer footer";
  min-height: 100vh;
}

.header  { grid-area: header; }
.sidebar { grid-area: sidebar; }
.main    { grid-area: main; }
.aside   { grid-area: aside; }
.footer  { grid-area: footer; }`,
            explanation: "grid-template-areas позволяет визуально задать раскладку страницы"
          }
        ],
        keyPoints: [
          "Grid работает в двух измерениях (строки + столбцы)",
          "grid-template-columns/rows определяют структуру сетки",
          "fr — гибкая единица для распределения пространства",
          "grid-template-areas для визуальной раскладки страницы",
          "repeat(3, 1fr) — сокращение для повторяющихся столбцов"
        ]
      },
      {
        id: 15,
        topic: "Адаптивный дизайн",
        category: "css",
        content: "Media queries для разных экранов: @media (max-width: 768px). Mobile-first подход: сначала стили для мобильных, затем для больших экранов. Единицы: rem (относительно root), em (относительно родителя), vw/vh (viewport), % (процент от родителя).",
        detailedContent: `Адаптивный дизайн — подход к созданию веб-сайтов, который работает корректно на устройствах любого размера: смартфоны, планшеты, ноутбуки, мониторы.

Media Queries позволяют применять разные стили в зависимости от характеристик устройства (ширина экрана, ориентация и т.д.).

Mobile-first подход: сначала пишем стили для мобильных устройств (самый маленький экран), затем добавляем media queries для бо́льших экранов с min-width. Это рекомендуемый подход, так как мобильные пользователи составляют большинство.

Адаптивные единицы измерения:
- rem: относительно корневого элемента (обычно 16px)
- em: относительно родительского элемента
- vw/vh: процент от ширины/высоты viewport
- %: процент от родительского элемента
- min()/max()/clamp(): функции для адаптивных размеров

Стандартные точки излома (breakpoints):
- Mobile: до 640px
- Tablet: 640-1024px
- Desktop: 1024px+`,
        examples: [
          {
            title: "Mobile-first с media queries",
            code: `/* Mobile стили (по умолчанию) */
.container {
  padding: 1rem;
  flex-direction: column;
}

.card {
  width: 100%;
  margin-bottom: 1rem;
}

/* Tablet: 640px и выше */
@media (min-width: 640px) {
  .container {
    display: flex;
    flex-wrap: wrap;
  }
  .card { width: calc(50% - 0.5rem); }
}

/* Desktop: 1024px и выше */
@media (min-width: 1024px) {
  .container { max-width: 1200px; margin: 0 auto; }
  .card { width: calc(33.33% - 0.67rem); }
}`,
            explanation: "Mobile-first: базовые стили для мобильных, расширяем для больших экранов"
          },
          {
            title: "Адаптивный текст с clamp()",
            code: `/* Адаптивный размер текста */
h1 {
  font-size: clamp(1.5rem, 4vw, 3rem);
  /* min: 1.5rem, preferred: 4vw, max: 3rem */
}

/* Адаптивные отступы */
.section {
  padding: clamp(2rem, 5vw, 5rem);
}`,
            explanation: "clamp() автоматически адаптирует размер между min и max"
          }
        ],
        keyPoints: [
          "Mobile-first: пишем для мобильных сначала, затем min-width",
          "@media (min-width: 640px) для планшетов",
          "@media (min-width: 1024px) для десктопов",
          "clamp(min, preferred, max) для адаптивных размеров",
          "vw/vh — единицы относительно размера экрана"
        ]
      }
    ],
    react: [
      {
        id: 16,
        topic: "Компоненты и JSX",
        category: "react",
        content: "Компоненты — строительные блоки React. Функциональные компоненты — обычные JS функции, возвращающие JSX. JSX — синтаксис похожий на HTML, но это JavaScript. Используйте className вместо class, camelCase для атрибутов.",
        detailedContent: `Компоненты — сердце React. Это переиспользуемые блоки UI, каждый из которых отвечает за свою часть интерфейса. Компонент — это JS функция, которая возвращает JSX (разметку).

JSX (JavaScript XML) — расширение синтаксиса JavaScript, который похож на HTML. JSX не работает в обычном JS — его компилирует Babel в вызовы React.createElement().

Важные отличия JSX от HTML:
- class → className (class зарезервированное слово в JS)
- for → htmlFor
- style: объект, не строка: style={{ color: 'red', fontSize: '16px' }}
- Все теги должны быть закрыты: <br /> не <br>
- Одна корневая StructuredClone: <>...</> или <div>...</div>

Компоненты:
- Имя компонента начинается с заглавной буквы
- Могут принимать props (свойства)
- Могут содержать другие компоненты
- Могут быть вложенными`,
        examples: [
          {
            title: "Простой компонент",
            code: `function Welcome({ name, age }) {
  return (
    <div className="card">
      <h2>Привет, {name}!</h2>
      <p>Тебе {age} лет.</p>
    </div>
  );
}

// Использование компонента
function App() {
  return (
    <div>
      <Welcome name="Алеша" age={25} />
      <Welcome name="Маша" age={22} />
    </div>
  );
}`,
            explanation: "Компонент — функция, принимающая props и возвращающая JSX"
          },
          {
            title: "JSX с выражениями",
            code: `function UserCard({ user }) {
  const fullName = user.first + " " + user.last;

  return (
    <div style={{ padding: "1rem", border: "1px solid #ddd" }}>
      <h3>{fullName}</h3>
      <p>Email: {user.email}</p>
      {/* Это JSX комментарий */}
      <span>{user.verified ? "✓ Верифицирован" : "Не верифицирован"}</span>
    </div>
  );
}`,
            explanation: "Фигурные скобки {} позволяют вставить JS выражения в JSX"
          }
        ],
        keyPoints: [
          "Компонент — функция, возвращающая JSX",
          "Имя компонента начинается с заглавной буквы",
          "className вместо class, htmlFor вместо for",
          "style — объект: style={{ color: 'red' }}",
          "{} позволяют вставить JS выражения в JSX"
        ]
      },
      {
        id: 17,
        topic: "Хуки: useState и useEffect",
        category: "react",
        content: "useState — для состояния компонента. Возвращает [значение, функцию для изменения]. useEffect — для побочных эффектов (запросы, подписки). Запускается после рендера. Массив зависимостей контролирует перезапуск.",
        detailedContent: `Хуки (hooks) — функции React, которые позволяют использовать состояние и другие возможности React в функциональных компонентах. Все хуки начинаются с use.

useState:
Хук для управления состоянием компонента. Возвращает массив из двух элементов: текущее значение состояния и функция для его обновления. При изменении состояния компонент перерендерится.

useEffect:
Хук для побочных эффектов — действий, которые нужно выполнить после рендера:
- Загрузка данных (API запросы)
- Подписки на события
- Работа с DOM напрямую

Массив зависимостей (dependencies):
- [] — эффект выполняется один раз (при монтировании)
- [dep1, dep2] — выполняется когда dep1 или dep2 меняются
- Без массива — выполняется после каждого рендера

Правила хуков:
- Вызывайте хуки только на верхнем уровне компонента
- Не вызывайте хуки внутри условий или циклов`,
        examples: [
          {
            title: "useState — счетчик",
            code: `import { useState } from 'react';

function Counter() {
  const [count, setCount] = useState(0);

  return (
    <div>
      <p>Счетчик: {count}</p>
      <button onClick={() => setCount(count + 1)}>
        +1
      </button>
      <button onClick={() => setCount(0)}>
        Сброс
      </button>
    </div>
  );
}`,
            explanation: "useState(0) начальное значение 0, setCount обновляет и вызывает рендер"
          },
          {
            title: "useEffect — загрузка данных",
            code: `import { useState, useEffect } from 'react';

function UserProfile({ userId }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchUser() {
      const response = await fetch(
        \`/api/users/\${userId}\`
      );
      const data = await response.json();
      setUser(data);
      setLoading(false);
    }

    fetchUser();
  }, [userId]);
  // Перезапускается когда userId меняется

  if (loading) return <p>Загрузка...</p>;
  return <h1>{user.name}</h1>;
}`,
            explanation: "[userId] — эффект перезапускается при смене userId"
          }
        ],
        keyPoints: [
          "useState возвращает [значение, функция-сеттер]",
          "Изменение state через сеттер вызывает перерендер",
          "useEffect для побочных эффектов после рендера",
          "[] в useEffect — эффект выполняется один раз",
          "Хуки нельзя вызывать внутри условий или циклов"
        ]
      },
      {
        id: 18,
        topic: "Props и передача данных",
        category: "react",
        content: "Props — свойства компонента, передаются от родителя к ребенку. Неизменяемы (immutable). Деструктуризация для удобства: ({name, age}). Children prop для вложенного контента. PropTypes для валидации типов.",
        detailedContent: `Props (properties) — основной способ передачи данных в React. Данные текут от родительского компонента к дочернему (one-way data flow).

Ключевые особенности props:
- Неизменяемы: компонент не может изменить свои props
- Любой JS тип: строки, числа, объекты, массивы, функции
- Функции как props: позволяют дочернему компоненту вызвать функцию родителя (callback)
- children: специальный prop для вложенного контента

Передача данных вверх (от ребенка к родителю):
Осуществляется через callback функции. Родитель передает функцию как prop, ребенок вызывает ее с нужными данными.

PropTypes для валидации:
Позволяют указать ожидаемые типы props. При неправильном использовании выводится предупреждение в консоли (только в development).`,
        examples: [
          {
            title: "Props и callback",
            code: `// Родительский компонент
function TodoApp() {
  const [todos, setTodos] = useState([]);

  const addTodo = (text) => {
    setTodos([...todos, { text, done: false }]);
  };

  return (
    <div>
      <TodoInput onAdd={addTodo} />
      {todos.map((todo, i) => (
        <TodoItem key={i} text={todo.text} />
      ))}
    </div>
  );
}

// Дочерний компонент
function TodoInput({ onAdd }) {
  const [value, setValue] = useState("");
  return (
    <input
      value={value}
      onChange={e => setValue(e.target.value)}
      onKeyPress={e => {
        if (e.key === "Enter") {
          onAdd(value);
          setValue("");
        }
      }}
    />
  );
}`,
            explanation: "onAdd — callback, передающий данные от ребенка к родителю"
          },
          {
            title: "Children prop",
            code: `function Card({ title, children }) {
  return (
    <div className="card">
      <h3>{title}</h3>
      <div className="card-body">
        {children}  {/* Вложенный контент */}
      </div>
    </div>
  );
}

// Использование
<Card title="Информация">
  <p>Любой контент здесь...</p>
  <button>Кнопка</button>
</Card>`,
            explanation: "children позволяет передать любой JSX контент внутрь компонента"
          }
        ],
        keyPoints: [
          "Props передаются от родителя к ребенку",
          "Props неизменяемы — нельзя менять внутри компонента",
          "Функции-callback передаются как props для events",
          "children — специальный prop для вложенного контента",
          "PropTypes для валидации типов в development"
        ]
      },
      {
        id: 19,
        topic: "Условный рендеринг и списки",
        category: "react",
        content: "Условный рендеринг: тернарный оператор (condition ? <A/> : <B/>), логический оператор (condition && <Component/>). Списки: map() для преобразования массива в компоненты. Обязателен уникальный key для оптимизации.",
        detailedContent: `Условный рендеринг и рендеринг списков — две часто используемые техники в React.

Условный рендеринг позволяет показывать или скрывать компоненты в зависимости от условия. Есть несколько способов:
1. Тернарный оператор: condition ? <ComponentA/> : <ComponentB/>
2. Логический И: condition && <Component/> — если condition true, рендерится Component
3. if/else: можно вернуть разные JSX из функции через обычный if

Важно: && с числом 0 рендерит 0, а не ничего. Используйте Boolean() или тернарный оператор.

Рендеринг списков:
Массивы данных преобразуются в компоненты через .map(). React требует уникальный key для каждого элемента списка для оптимизации рендеринга.

key:
- Должен быть уникальным среди соседних элементов
- Не передается как prop компоненту
- Используйте id из данных, не index массива (если список меняется)`,
        examples: [
          {
            title: "Условный рендеринг",
            code: `function Dashboard({ user, isLoading }) {
  // Способ 1: if/else
  if (isLoading) return <Spinner />;

  // Способ 2: тернарный
  const greeting = user
    ? <h1>Привет, {user.name}!</h1>
    : <h1>Войдите в систему</h1>;

  // Способ 3: && оператор
  const adminPanel = user?.isAdmin && <AdminPanel />;

  return (
    <div>
      {greeting}
      {adminPanel}
      {user && <p>Email: {user.email}</p>}
    </div>
  );
}`,
            explanation: "Каждый способ подходит для разных случаев"
          },
          {
            title: "Рендеринг списка",
            code: `function TodoList({ todos }) {
  if (todos.length === 0) {
    return <p>Нет задач!</p>;
  }

  return (
    <ul>
      {todos.map((todo) => (
        <li
          key={todo.id}  {/* уникальный key */}
          className={todo.done ? "done" : ""}
        >
          {todo.text}
        </li>
      ))}
    </ul>
  );
}`,
            explanation: "key={todo.id} для уникальной идентификации элементов списка"
          }
        ],
        keyPoints: [
          "Тернарный оператор для if/else рендеринг",
          "&& для рендеринга когда условие true",
          "map() преобразует массив данных в массив компонентов",
          "key — обязателен и должен быть уникальным",
          "Не используйте index как key если список может меняться"
        ]
      }
    ]
  },
  quizzes: {
    python: {
      id: 'quiz_python',
      title: 'Тест по Python',
      questions: [
        {
          id: 1,
          question: 'Какой тип данных вернёт выражение type(3.14)?',
          options: ['int', 'float', 'str', 'number'],
          correctAnswer: 1
        },
        {
          id: 2,
          question: 'Какой цикл используется для перебора элементов списка?',
          options: ['while', 'for', 'loop', 'each'],
          correctAnswer: 1
        },
        {
          id: 3,
          question: 'Как определить функцию в Python?',
          options: ['function myFunc()', 'def myFunc():', 'fn myFunc()', 'func myFunc():'],
          correctAnswer: 1
        },
        {
          id: 4,
          question: 'Какой метод добавляет элемент в конец списка?',
          options: ['add()', 'push()', 'append()', 'insert()'],
          correctAnswer: 2
        },
        {
          id: 5,
          question: 'Что выведет print(len([1, 2, 3]))?',
          options: ['[1, 2, 3]', '3', 'error', '6'],
          correctAnswer: 1
        }
      ]
    },
    javascript: {
      id: 'quiz_javascript',
      title: 'Тест по JavaScript',
      questions: [
        {
          id: 1,
          question: 'Какое ключевое слово создаёт константу?',
          options: ['var', 'let', 'const', 'constant'],
          correctAnswer: 2
        },
        {
          id: 2,
          question: 'Чем стрелочная функция отличается от обычной?',
          options: ['Быстрее работает', 'Не имеет собственного this', 'Не может принимать аргументы', 'Всегда асинхронная'],
          correctAnswer: 1
        },
        {
          id: 3,
          question: 'Какой метод массива создаёт новый массив с отфильтрованными элементами?',
          options: ['map()', 'filter()', 'reduce()', 'forEach()'],
          correctAnswer: 1
        },
        {
          id: 4,
          question: 'Что возвращает async функция?',
          options: ['undefined', 'null', 'Promise', 'callback'],
          correctAnswer: 2
        },
        {
          id: 5,
          question: 'Какой метод НЕ возвращает новый массив?',
          options: ['map()', 'filter()', 'forEach()', 'slice()'],
          correctAnswer: 2
        }
      ]
    },
    html: {
      id: 'quiz_html',
      title: 'Тест по HTML',
      questions: [
        {
          id: 1,
          question: 'Какой тег используется для основного контента страницы?',
          options: ['<div>', '<main>', '<content>', '<body>'],
          correctAnswer: 1
        },
        {
          id: 2,
          question: 'Какой тег создаёт навигационное меню?',
          options: ['<menu>', '<nav>', '<navigation>', '<header>'],
          correctAnswer: 1
        },
        {
          id: 3,
          question: 'Какой атрибут input делает поле обязательным?',
          options: ['mandatory', 'required', 'validate', 'necessary'],
          correctAnswer: 1
        },
        {
          id: 4,
          question: 'Где размещается тег <title>?',
          options: ['<body>', '<head>', '<header>', '<main>'],
          correctAnswer: 1
        },
        {
          id: 5,
          question: 'Какой тег используется для подвала страницы?',
          options: ['<bottom>', '<footer>', '<end>', '<closing>'],
          correctAnswer: 1
        }
      ]
    },
    css: {
      id: 'quiz_css',
      title: 'Тест по CSS',
      questions: [
        {
          id: 1,
          question: 'Какой селектор имеет наивысший приоритет?',
          options: ['Класс (.class)', 'ID (#id)', 'Элемент (div)', 'Псевдокласс (:hover)'],
          correctAnswer: 1
        },
        {
          id: 2,
          question: 'Какое свойство создаёт flex-контейнер?',
          options: ['flex: 1', 'display: flex', 'flex-direction: row', 'justify-content: center'],
          correctAnswer: 1
        },
        {
          id: 3,
          question: 'Для чего используется justify-content?',
          options: ['Выравнивание по поперечной оси', 'Выравнивание по главной оси', 'Отступы между элементами', 'Направление flex'],
          correctAnswer: 1
        },
        {
          id: 4,
          question: 'Какое свойство создаёт grid-контейнер?',
          options: ['grid: on', 'display: grid', 'grid-template: auto', 'grid-columns: 1fr'],
          correctAnswer: 1
        },
        {
          id: 5,
          question: 'Какая единица относительна к размеру viewport?',
          options: ['rem', 'em', 'vw', '%'],
          correctAnswer: 2
        }
      ]
    },
    react: {
      id: 'quiz_react',
      title: 'Тест по React',
      questions: [
        {
          id: 1,
          question: 'Что возвращает хук useState?',
          options: ['Только значение', 'Только функцию', 'Массив [значение, функция]', 'Объект {value, setter}'],
          correctAnswer: 2
        },
        {
          id: 2,
          question: 'Для чего нужен useEffect?',
          options: ['Создание состояния', 'Побочные эффекты', 'Маршрутизация', 'Валидация props'],
          correctAnswer: 1
        },
        {
          id: 3,
          question: 'Как передать данные от родителя к ребёнку?',
          options: ['state', 'props', 'context', 'refs'],
          correctAnswer: 1
        },
        {
          id: 4,
          question: 'Что обязательно при рендеринге списка?',
          options: ['className', 'key', 'id', 'index'],
          correctAnswer: 1
        },
        {
          id: 5,
          question: 'Какой атрибут заменяет class в JSX?',
          options: ['cssClass', 'className', 'class', 'htmlClass'],
          correctAnswer: 1
        }
      ]
    }
  },
  faq: [
    {
      id: 1,
      question: "Как установить Python?",
      answer: "Скачайте установщик с python.org, запустите его и обязательно отметьте галочку 'Add Python to PATH'. После установки проверьте в командной строке: python --version",
      category: "python"
    },
    {
      id: 2,
      question: "Какую IDE использовать для Python?",
      answer: "Для начинающих рекомендуется PyCharm Community (бесплатная) или VS Code с расширением Python. Также подойдут Jupyter Notebook для интерактивной работы и обучения.",
      category: "python"
    },
    {
      id: 3,
      question: "В чем разница между let и const?",
      answer: "const используется для переменных, которые не будут переназначены. let — для переменных, которые могут изменяться. const не делает объект неизменяемым, только предотвращает переназначение самой переменной.",
      category: "javascript"
    },
    {
      id: 4,
      question: "Как подключить CSS к HTML?",
      answer: "Три способа: 1) Внешний файл через <link rel='stylesheet' href='style.css'> в head. 2) Внутренние стили через тег <style> в head. 3) Инлайн стили через атрибут style на элементе. Рекомендуется внешний файл.",
      category: "css"
    },
    {
      id: 5,
      question: "Как создать React приложение?",
      answer: "Используйте команду: npx create-react-app my-app. Затем cd my-app и npm start для запуска. Или используйте Vite для более быстрой сборки: npm create vite@latest my-app -- --template react",
      category: "react"
    },
    {
      id: 6,
      question: "Что такое замыкание в JavaScript?",
      answer: "Замыкание — функция, которая запоминает переменные из внешней области видимости, даже после завершения внешней функции. Используется для создания приватных переменных и модулей.",
      category: "javascript"
    }
  ]
};

export const INITIAL_MESSAGE = {
  role: 'assistant',
  content: 'Здравствуйте! 👋 Я AI-помощник образовательной платформы. Помогу с вопросами по **Python**, **JavaScript**, **HTML**, **CSS** и **React**. Задавайте любые вопросы!',
  timestamp: new Date(),
  id: Date.now()
};

// Вспомогательные функции
export const getAllMaterials = () => {
  return Object.values(COURSE_DATA.materials).flat();
};

export const getMaterialsByCategory = (category) => {
  if (category === 'all') return getAllMaterials();
  return COURSE_DATA.materials[category] || [];
};

export const getFAQByCategory = (category) => {
  if (!category || category === 'all') return COURSE_DATA.faq;
  return COURSE_DATA.faq.filter(item => item.category === category);
};

export const getQuizByCategory = (category) => {
  return COURSE_DATA.quizzes[category] || null;
};

export const getAllQuizIds = () => {
  return Object.values(COURSE_DATA.quizzes).map(quiz => quiz.id);
};